<template>

    <div class="tw-m-5">

        <div class="tw-mb-1 tw-text-gray-600 label">{{ label }}</div>

        <small v-if="instruction"
               class="tw-block tw-mb-3 tw-text-gray-500 label tw-text-muted">{{ instruction }}</small>

        <div class="mt-1">

            <input type="text"
                   :placeholder="placeholder"
                   class="focus:tw-border-blue-300 focus:tw-outline-none focus:tw-shadow-outline-blue form-control form-input sm:tw-leading-5 sm:tw-text-sm tw-border tw-border-gray-300 tw-border-solid tw-duration-150 tw-ease-in-out tw-mt-1 tw-px-3 tw-py-2 tw-rounded-md tw-shadow-sm tw-transition tw-w-full"
                   @blur="setValue()"
                   v-model="input"/>

        </div>

    </div>

</template>

<script>

export default {

    data() {
        return {
            input: this.options[this.optionsProperty] ?? '',
        };
    },

    props: {
        label: {
            type: String,
            required: true,
        },

        instruction: {
            type: String,
        },

        options: {
            type: Object,
            required: true,
        },

        optionsProperty: {
            required: true,
        },

        placeholder: {
            type: String,
            required: true,
        },
    },

    methods: {
        setValue() {
            // Set in options.
            this.$set(this.options, this.optionsProperty, this.input);

            // Emit for whoever wants to know.
            this.$emit('valueChange');
        }
    },
}

</script>
